import React, { Component } from 'react';
import Form from '../Form/Form';
import Readmore from "../Readmore/Readmore"
import Popup from '../Popup/Popup';

class App extends Component {
  constructor() {
    super();
    this.state = {
      isPoping: false,
      popupData: {},
      isLoading: false
    }
    this.triggerPopup = this.triggerPopup.bind(this);
  }
  triggerPopup(data) {
    this.setState({
      isPoping: !this.state.isPoping,
    });
    if (data) {
      this.setState({
        popupData: data
      })
    }
  }
  render() {
    return (
      <div className="App-LeadForm">
      <Popup
        popupData={this.state.popupData}
        triggerPopup={this.triggerPopup}
        isPoping={this.state.isPoping} />
        <Readmore />
        <Form triggerPopup={this.triggerPopup} />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Components/App/App.jsx